import { createContext, useContext } from 'react';

export type CookbookContext = {
  direction: 'ltr' | 'rtl';
  domain?: 'tools' | 'consumer';
  themeMode: 'light' | 'lightHighContrast' | 'dark';
};

export const context = createContext<CookbookContext | undefined>(undefined);

context.displayName = 'CookbookContext';

export const CookbookContextProvider = context.Provider;

export const useCookbookContext = () => useContext(context);
